import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import blockStyles from '../styles/block.styles';
export default css `
  ${componentStyles}
  ${blockStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
    container-type: inline-size;
  }

  :host([hide-header]) .container {
    padding-top: var(--p-gallery-padding-top, var(--p-gallery-gap));
    @container (max-width: 700px) {
      padding-top: var(--p-gallery-gap-mobile, 2px);
    }
  }

  .container {
    width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
    margin-inline: auto;
  }

  .header {
    max-width: var(--p-text-max-width);
    margin-bottom: var(--p-gap);
  }

  /**
--------------------------------------------------
* Caption
--------------------------------------------------
*/

  figcaption {
    opacity: var(--p-image-caption-text-opacity, var(--p-text-meta-opacity));
    width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
    margin-inline: auto;
    padding-top: var(--p-font-size-small);
  }

  .text {
    max-width: var(--p-text-max-width);
    font-size: var(--p-image-caption-font-size, var(--p-font-size-small));
    line-height: 1.3;
  }

  .text-align-center .text,
  .text-align-center .header {
    text-align: center;
    margin-inline: auto;
  }

  .text-align-right .text,
  .text-align-right .header {
    text-align: right;
    margin-left: auto;
  }

  /**
--------------------------------------------------
* Gallery
--------------------------------------------------
*/
  .gallery-wrap {
    display: grid;
    gap: var(--p-gallery-gap, var(--p-gap));
    grid-template-columns: repeat(12, 1fr);

    @container (max-width: 700px) {
      gap: var(--p-gallery-gap-mobile, 2px);
    }
  }

  /**
--------------------------------------------------
* Layout 1: Square
--------------------------------------------------
*/
  .layout-1 ::slotted(p-gallery-item) {
    aspect-ratio: 1/1;
  }

  /**
--------------------------------------------------
* Layout 2: Portrait
--------------------------------------------------
*/

  .layout-2 ::slotted(p-gallery-item) {
    aspect-ratio: 5/7;
    grid-column: span 4;
  }

  /**
--------------------------------------------------
* Layout 3: Landscape
--------------------------------------------------
*/

  .layout-3 ::slotted(p-gallery-item) {
    aspect-ratio: 7/5;
    grid-column: span 4;
  }

  /**
--------------------------------------------------
* Layout 4: Square + Landscape alternating
--------------------------------------------------
*/

  .layout-4 ::slotted(p-gallery-item:nth-of-type(4n + 1)),
  .layout-4 ::slotted(p-gallery-item:nth-of-type(4n + 4)) {
    aspect-ratio: 455/370;
    grid-column: span 4;
  }

  .layout-4 ::slotted(p-gallery-item:nth-of-type(4n + 2)),
  .layout-4 ::slotted(p-gallery-item:nth-of-type(4n + 3)) {
    grid-column: span 8;
    aspect-ratio: 770/370;
  }

  /**
--------------------------------------------------
* Layout 5: Landscape big + 2 on the side alternating
--------------------------------------------------
*/

  .layout-5 ::slotted(p-gallery-item:nth-of-type(6n + 1)),
  .layout-5 ::slotted(p-gallery-item:nth-of-type(6n + 5)) {
    aspect-ratio: 770/615;
    grid-column: span 8;
    grid-row: span 2;
  }
  .layout-5 ::slotted(p-gallery-item:nth-of-type(6n + 2)),
  .layout-5 ::slotted(p-gallery-item:nth-of-type(6n + 3)),
  .layout-5 ::slotted(p-gallery-item:nth-of-type(6n + 4)),
  .layout-5 ::slotted(p-gallery-item:nth-of-type(6n + 6)) {
    aspect-ratio: 455/300;
    grid-column: span 4;
  }

  /**
--------------------------------------------------
* Layout 6: Big + 4 on the side alternating
--------------------------------------------------
*/

  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 1)),
  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 8)) {
    aspect-ratio: 770/615;
    grid-column: span 6;
    grid-row: span 2;
  }
  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 2)),
  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 3)),
  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 4)),
  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 5)),
  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 6)),
  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 7)),
  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 9)),
  .layout-6 ::slotted(p-gallery-item:nth-of-type(10n + 10)) {
    aspect-ratio: 455/300;
    grid-column: span 3;
  }

  /**

--------------------------------------------------
* Slotted content
--------------------------------------------------
*/
  ::slotted(p-gallery-item) {
    grid-column: span 4; /* default on mobile */
  }
  slot[name='header']::slotted(p:last-of-type) {
    --p-p-margin-bottom: 0;
    --p-preamble-margin-bottom: 0;
  }
`;
